var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDownloadFlatTray = function SvgDownloadFlatTray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#222",
    d: "M10 2.5c.46 0 .833.373.833.833v8.822l2.744-2.744a.833.833 0 1 1 1.179 1.178l-4.167 4.167a.833.833 0 0 1-1.178 0l-4.167-4.167a.833.833 0 0 1 1.179-1.178l2.744 2.744V3.333c0-.46.373-.833.833-.833ZM5 15.833A.833.833 0 0 0 5 17.5h10a.833.833 0 0 0 0-1.667H5Z"
  })));
};
export default SvgDownloadFlatTray;